import React, { useContext, useState } from 'react'
import { CaretDownIcon, CaretUpIcon, HandbagIcon, InfoIcon } from '@phosphor-icons/react'
import { StoreContext } from "@context/StoreContext"
import UserContext from '@context/UserContext'
import {formatPrice} from '@utils'
import Tooltip from '@components/common/Tooltip'

export const Checkout = () => {
    const {checkout} = useContext(StoreContext);
	const { user } = useContext(UserContext)
    const emptyCart = checkout?.lines?.edges?.length === 0;
	const isUSCustomer = user?.defaultAddress?.countryCodeV2 === "US" ? true : false;
    const importDuties = checkout?.cost?.subtotalAmount?.amount * .35;
    const [showPriceDetails, setShowPriceDetails] = useState(false)

    
    const handleProceedToCheckout = () => {
        if(process.env.GATSBY_STORE !== "PH") {
            window.location.href = checkout?.checkoutUrl.replace("blackboughswim.com", "checkout.blackboughswim.com");
        } else {
            window.location.href = checkout?.checkoutUrl.replace("blackboughswim.ph", "checkout.blackboughswim.ph");
        }
    }
    

    return (
        !emptyCart ? (
            <section className={`self-end space-y-4 w-full fixed bottom-0`}>
                <div className={`bg-white`}>
                    <div className="flex justify-end relative mb-2">
                        <div className={`absolute border-t border-gray-400 h-0.5 w-full top-[50%] bottom-[50%] z-0 shadow-[0px_-3px_7px_rgba(0,0,0,0.5)]`}></div>
                        <div className="mr-3 bg-white z-50">
                            {!showPriceDetails ? (
                                <CaretUpIcon
                                    size={28}
                                    weight="light"
                                    className="cursor-pointer border border-gray-400 rounded-sm p-0.5"
                                    onClick={() =>
                                        setShowPriceDetails(!showPriceDetails)
                                    }
                                />
                            ) : (
                                <CaretDownIcon
                                    size={28}
                                    weight="light"
                                    className="cursor-pointer border border-gray-400 rounded-sm p-0.5"
                                    onClick={() =>
                                        setShowPriceDetails(!showPriceDetails)
                                    }
                                />
                            )}
                        </div>
                    </div>
                    <div className="space-y-3 text-[#6D6D6D] px-4">
                        <div className="flex flex-nowrap justify-between">
                            <div className="flex flex-nowrap items-center gap-1 flex-1 text-tertiary">
								<span>Subtotal</span>
								{(isUSCustomer && !showPriceDetails) && (
									<span className='text-xs'>(expand to view estimated duties)</span>
								)}
							</div>
                            <span className="text-black">
                                {
                                    formatPrice(
                                        checkout?.cost?.subtotalAmount?.currencyCode,
                                        checkout?.cost?.subtotalAmount?.amount
                                    )
                                }
                            </span>
                        </div>
                        
                        
                        {
                            showPriceDetails && (
                                <>
                                    <div className="flex flex-nowrap justify-between">
                                        <span className="flex-1 text-tertiary">Shipping Estimate</span>
                                        <span className="text-black">Next Step</span>
                                    </div>

									{isUSCustomer && (
										<div className="flex flex-nowrap justify-between">
											<div className="flex items-center gap-x-1.5  flex-nowrap flex-1 text-tertiary">
												<span>Est. Import Duties</span>
												<Tooltip 
													text={<>
														<p>
															Estimated import duties may apply based on your country’s regulations. 
															For detailed information, please see our 
															<a 
																className='inline-block underline underline-offset-2 ml-1'
																href="/tariffs" 
																target='_blank'
															>tariffs guide.</a>
														</p>
													</>}
													toolTipBg='bg-black'
													offsetBubble='-top-3'
													offsetBubblePointer='top-[3.75rem]'
													maxWidth='w-48'
												>
													<InfoIcon size={20} weight='light' />
												</Tooltip>
											</div>
											<span className="text-black">
                                                {
                                                    formatPrice(
                                                        checkout?.cost?.subtotalAmount?.currencyCode,
                                                        importDuties ? importDuties : 0
                                                    )
                                                }
                                            </span> 
										</div>
									)}

                                    <div className="flex flex-nowrap justify-between">
                                        <span className="flex-1 text-tertiary">Taxes</span>
                                        <span className="text-black">
                                            {
                                                formatPrice(
                                                    checkout?.cost?.subtotalAmount?.currencyCode,
                                                    checkout?.cost?.totalTaxAmount ? checkout?.cost?.totalTaxAmount?.amount : 0
                                                )
                                            }
                                        </span>
                                    </div>
                                </>
                            )
                        }
                    </div>

                    <div className="p-4">
                        <button 
							className="btn-primary flex items-center justify-center p-3 w-full" 
							onClick={() => handleProceedToCheckout()} 
							aria-label='Proceed to Checkout'
						>
                            <HandbagIcon size={20} weight="light" className="mr-4" />
                            Proceed to Checkout
                        </button>
                    </div>
                </div>
            </section>
        ) : null
    )
}



export default Checkout;